import { cn } from "utils";

// GitHub-style repository label: a small rounded pill after the repo name.
// visibility: public | private | internal. flag: archived | disabled.
// Like GitHub, an archived repo reads "Public archive" in amber; disabled reads "Disabled" in red.
const PILL = "inline-flex items-center rounded-full border px-2 py-px text-xs font-medium leading-5 whitespace-nowrap";

// Amber/red are status decoration (like GitHub's attention/danger colors), the one place palette colors are used.
// const FLAG_STYLES = {
//   archived: "border-amber-500/50 text-amber-700 dark:text-amber-400",
//   disabled: "border-destructive/50 text-destructive",
// };

const capitalize = (value) => (value ? value.charAt(0).toUpperCase() + value.slice(1) : "");

export function repoLabelText({ visibility, flag }) {
  if (flag === "archived") return visibility ? `${capitalize(visibility)} archive` : "Archived";
  if (flag === "disabled") return "Disabled";
  return capitalize(visibility);
}

export default function RepoLabel({ visibility, flag, className }) {
  const text = repoLabelText({ visibility, flag });
  if (!text) return null;
  return <span className={cn(PILL, "text-muted-foreground", className)}>{text}</span>;
}
